import type * as React from 'react'

import { Popover } from '@buffer-mono/popcorn'

import type {
  ChannelScoreDetails,
  CommentsScoreSummary,
} from '../../hooks/scoring/useCommentsScore'

import { ScoreContent } from './ScoreContent'
import { useDelayedHover } from '../../hooks/ui/useDelayedHover'

import styles from './CommentsScorePopover.module.css'

import type { JSX } from 'react'

type CommentsScorePopoverProps = {
  children: React.ReactNode
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  commentsScore: ChannelScoreDetails | CommentsScoreSummary
  isAllChannels?: boolean
}

export const CommentsScorePopover = ({
  children,
  isOpen,
  onOpenChange,
  commentsScore,
  isAllChannels = false,
}: CommentsScorePopoverProps): JSX.Element => {
  const { handleMouseEnter, handleMouseLeave } = useDelayedHover({
    onOpen: () => onOpenChange(true),
    onClose: () => onOpenChange(false),
    isOpen,
    openDelayDuration: 200,
  })

  return (
    <Popover defaultOpen open={isOpen} onOpenChange={onOpenChange}>
      <Popover.Trigger
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </Popover.Trigger>
      <Popover.Content
        side="bottom"
        align="start"
        className={styles.popoverContent}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        arrow
      >
        <ScoreContent
          commentsScore={commentsScore}
          isAllChannels={isAllChannels}
        />
      </Popover.Content>
    </Popover>
  )
}
